var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select-option',_vm._g(_vm._b({attrs:{"disabled":_vm.disabled,"title":_vm.title,"value":_vm.value}},'a-select-option',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }